import {
  BadgeCheck,
  Briefcase,
  ClipboardList,
  Mail,
  MessageSquare,
  Sparkles,
  ShieldCheck,
  Target,
  UserRound,
  UsersRound,
  Wallet,
  Wrench,
} from 'lucide-react';
import type { NavItem } from 'shared/components/AppShell';
import type { AppRoles } from 'shared/auth/roles';
import { paths } from 'shared/routing/paths';

export const ADMIN_NAV: NavItem[] = [
  { label: 'Users', to: paths.admin.experts, icon: UserRound },
  { label: 'Campaigns', to: paths.admin.campaigns, icon: Briefcase },
  { label: 'Projects/Jobs', to: paths.admin.projectsJobs, icon: ClipboardList },
  { label: 'Customers', to: paths.admin.customers, icon: UsersRound },
  { label: 'Reviews', to: paths.admin.reviews, icon: BadgeCheck },
  { label: 'Emails', to: paths.admin.emails, icon: Mail },
  { label: 'Billing', to: paths.admin.billing, icon: Wallet },
  { label: 'Message Board', to: paths.admin.messageBoard, icon: MessageSquare },
  { label: 'Opportunities', to: paths.admin.opportunities, icon: Target },
  { label: 'Synthetic Data', to: paths.admin.syntheticData, icon: Sparkles },
  { label: 'Permissions', to: paths.admin.permissions, icon: ShieldCheck },
  { label: 'Other', to: paths.admin.other, icon: Wrench },
];

export const CONTRACTOR_ADMIN_NAV: NavItem[] = [
  { label: 'Expert Search', to: paths.admin.expertsSearch, icon: UserRound },
  { label: 'Opportunities', to: paths.admin.opportunities, icon: Target },
];

export function getAdminNav({ isAdmin, isContractorAdmin }: Pick<AppRoles, 'isAdmin' | 'isContractorAdmin'>): NavItem[] {
  return isContractorAdmin && !isAdmin ? CONTRACTOR_ADMIN_NAV : ADMIN_NAV;
}
